module.exports = __webpack_public_path__ + "static/media/print-header-bg.e8663df6.webp";